import type { ReactNode } from 'react'

import { Icon } from '../../components/Icon'

/**
 * An advisory block (M23-T03), drawn on the appointment drawer `1182:6922`:
 * *"Call the patient before confirming. Confirming sends them the slot and the
 * hospital address."*
 *
 * `warn` is the default because that is what the frames use it for — a
 * consequence the admin should know about **before** they act, not an error
 * after. It is not an alert: an alert interrupts, this informs, so it carries
 * no `role="alert"` and does not steal focus.
 */
export function Callout({
  tone = 'warn',
  children,
}: {
  tone?: 'warn' | 'info'
  children: ReactNode
}) {
  const styles =
    tone === 'warn'
      ? 'bg-bed-warn-bg text-ink-1'
      : 'bg-accent-bg text-accent-ink'
  return (
    <div className={`flex items-start gap-2.5 rounded-xl px-4 py-3 ${styles}`}>
      <span aria-hidden="true" className="mt-0.5 shrink-0">
        <Icon name="info" size={16} />
      </span>
      <p className="text-sm">{children}</p>
    </div>
  )
}
